(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["viera-foundation"] && !Shopify.designMode) return;
  try {
    class VieraCartDrawer extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', event => {
        if (event.target.closest('[data-viera-drawer-close]')) this.close();
      });
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape') this.close();
      });
    }

    open() {
      this.hidden = false;
      document.body.style.overflow = 'hidden';
      const closeButton = this.querySelector('[data-viera-drawer-close]');
      if (closeButton) closeButton.focus();
    }

    close() {
      this.hidden = true;
      document.body.style.overflow = '';
    }

    async refresh() {
      const response = await fetch('/cart?section_id=cart-drawer');
      const html = await response.text();
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const replacement = documentFragment.querySelector('viera-cart-drawer');
      if (replacement) this.innerHTML = replacement.innerHTML;
      const count = this.querySelector('[data-viera-cart-count-value]');
      document.querySelectorAll('[data-viera-cart-count]').forEach(node => {
        node.textContent = count ? count.textContent : '0';
      });
    }
  }

  if (!customElements.get('viera-cart-drawer')) customElements.define('viera-cart-drawer', VieraCartDrawer);

  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-viera-cart-open]');
    const drawer = document.querySelector('viera-cart-drawer');
    if (opener && drawer) {
      event.preventDefault();
      drawer.open();
    }
  });

  document.addEventListener('change', event => {
    const offer = event.target.closest('[data-viera-offer]');
    if (!offer) return;
    const form = offer.closest('[data-viera-bundle-form]');
    form.querySelectorAll('[data-viera-offer-card]').forEach(card => card.classList.remove('is-selected'));
    offer.closest('[data-viera-offer-card]').classList.add('is-selected');
    const addon = form.querySelector('[data-viera-addon]');
    if (addon) {
      addon.checked = offer.value === 'triple';
      addon.disabled = offer.value === 'triple';
    }
  });

  document.addEventListener('click', event => {
    const dot = event.target.closest('[data-viera-gallery-dot]');
    if (!dot) return;
    const gallery = dot.closest('[data-viera-gallery]');
    const slides = gallery ? gallery.querySelectorAll('[data-viera-gallery-slide]') : [];
    const slide = slides[Number(dot.dataset.vieraGalleryDot)];
    if (slide) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  });

  document.addEventListener('scroll', event => {
    const track = event.target.closest ? event.target.closest('[data-viera-gallery-track]') : null;
    if (!track || !track.clientWidth) return;
    const gallery = track.closest('[data-viera-gallery]');
    const activeIndex = Math.round(track.scrollLeft / track.clientWidth);
    gallery.querySelectorAll('[data-viera-gallery-dot]').forEach((dot, index) => {
      dot.classList.toggle('is-current', index === activeIndex);
    });
  }, true);

  const updateVieraStorefrontChrome = () => {
    if (!document.querySelector('.viera')) return;

    document.querySelectorAll('header a').forEach(link => {
      if (link.textContent.trim().toUpperCase() !== '3-IN-1 PRIMER') return;
      link.href = '/products/viera-lymphatic-drops';
      const label = link.querySelector('span');
      if (label) label.textContent = 'Viera Lymphatic Drops';
      else link.textContent = 'Viera Lymphatic Drops';
    });

    document.querySelectorAll('.scroll-to-top-btn').forEach(button => button.remove());
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateVieraStorefrontChrome, { once: true });
  } else {
    updateVieraStorefrontChrome();
  }
  document.addEventListener('shopify:section:load', updateVieraStorefrontChrome);

  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-viera-bundle-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const status = form.querySelector('[data-viera-form-status]');
    const variantId = Number(form.dataset.mainVariant);
    const brushId = Number(form.dataset.brushVariant || 0);
    const offer = form.querySelector('[name="viera_offer"]:checked');
    const addon = form.querySelector('[data-viera-addon]');
    const quantity = offer && offer.value === 'triple' ? 3 : 1;
    const items = [{ id: variantId, quantity, properties: { '_Viera offer': quantity === 3 ? 'Buy 2 Get 1 Free' : 'Single bottle' } }];
    if (brushId && addon && addon.checked) {
      items.push({ id: brushId, quantity: 1, properties: { '_Viera add-on': quantity === 3 ? 'Free bundle gift' : 'Brush add-on' } });
    }
    button.disabled = true;
    if (status) status.textContent = form.dataset.loadingText;
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!response.ok) throw new Error('Cart request failed');
      if (status) status.textContent = form.dataset.successText;
      window.location.assign('/checkout');
    } catch (error) {
      if (status) status.textContent = form.dataset.errorText;
    } finally {
      button.disabled = false;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
